export default "__VITE_ASSET__DaV6JKPh__"